// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pE-z","smallCardRow":"qE-z","largeCardRow":"rE-z","productSearchRow":"sE-z","curatedRow":"tE-z"};